import React from 'react';
import "./SocialWidgets.css"

const YouTubeSubscribe = () => {
    return (
        <div className='social-panel youtube panel'>
            <iframe
                style={{ width: '100%', height: '48px' }}
                src="https://www.youtube.com/subscribe_embed?usegapi=1&channel=CostaCrociere&layout=full&origin=https%3A%2F%2Fwww.costapresscenter.com&gsrc=3p&jsh=m%3B%2F_%2Fscs%2Fabc-static%2F_%2Fjs%2Fk%3Dgapi.lb.it.Bm7L18-DFGA.O%2Fd%3D1%2Frs%3DAHpOoo93Dz0SZ-CseqFC-ngk7TIuUdjfIw%2Fm%3D__features__#_methods=onPlusOne%2C_ready%2C_close%2C_open%2C_resizeMe%2C_renderstart%2Concircled%2Cdrefresh%2Cerefresh&id=I3_1738661395297&_gfid=I3_1738661395297&parent=https%3A%2F%2Fwww.costapresscenter.com&pfname=&rpctoken=34167593"
                allowtransparency="true"
                title="YouTube Subscribe Button"
            ></iframe>
        </div>
    );
};

export default YouTubeSubscribe;
